import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 32 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

const StaggerWords = ({ text }) => (
  <motion.span
    aria-label={text}
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, margin: "-60px" }}
    transition={{ staggerChildren: 0.045, delayChildren: 0.1 }}
  >
    {text.split(" ").map((w, i) => (
      <span key={i} className="inline-block overflow-hidden pb-[0.08em] -mb-[0.08em] align-bottom">
        <motion.span
          className="inline-block mr-[0.28em]"
          variants={{ hidden: { y: "110%", opacity: 0 }, show: { y: 0, opacity: 1 } }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
        >
          {w}
        </motion.span>
      </span>
    ))}
  </motion.span>
);

export const Chapter = ({ id, name, title, sub }) => (
  <Reveal className="mb-14 md:mb-20">
    <div className="flex items-center gap-4 mb-6" data-testid={`chapter-${name.toLowerCase().replace(/\s+/g, "-")}-label`}>
      <span className="font-mono text-xs tracking-[0.35em] text-amber-600">{id}</span>
      <motion.span
        className="h-px flex-1 bg-slate-200 origin-left"
        initial={{ scaleX: 0 }}
        whileInView={{ scaleX: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
      />
      <span className="font-mono text-xs tracking-[0.35em] text-slate-400 uppercase">{name}</span>
    </div>
    <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#0B1528] max-w-3xl">
      <StaggerWords text={title} />
    </h2>
    {sub && <p className="mt-5 max-w-2xl text-base text-slate-500 leading-relaxed">{sub}</p>}
  </Reveal>
);
